import { getStockTransactions, setStockTransactionFilters } from '@state/reducers/stockTransactionReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { StockReason, StockTransactionDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import { StockReasonLabels } from '@utils/constants'
import { StocksTableTabs } from './StocksTable'
import StockTransactionForm from '../forms/StockTransactionForm'
import moment from 'moment'

export default function StockTransactionsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setStockTransactionFilters({}))
    }
  }, [])
    
  const columns: GridColumns<StockTransactionDto> = useMemo(
    () => [
      { field: 'occurredAt', headerName: 'Survenu le', width: 145, 
        valueGetter: (params) => moment(params.row.occurredAt).format('DD/MM/YYYY HH:mm') },
      { field: 'productBatch', headerName: 'Lot produit', width: 130, 
        valueGetter: (params) => params.row.productBatch.lotNumber },
      { field: 'productName', headerName: 'Produit', width: 200, 
        valueGetter: (params) => params.row.productBatch.productCatalog.name },
      { field: 'productGenericName', headerName: 'DCI', width: 140, 
        valueGetter: (params) => params.row.productBatch.productCatalog.genericName },
      { field: 'reason', headerName: 'Raison', width: 150, 
        valueGetter: (params) => StockReasonLabels[params.row.reason] },
      { field: 'unitsDelta', headerName: 'Quantité', width: 90, type: 'number', 
        valueGetter: (params) => `${params.row.reason === StockReason.INVENTORY_COUNT
          ? '=' : params.row.unitsDelta > 0 ? '+' : ''}${params.row.unitsDelta}` },
      { field: 'storageLocation', headerName: 'Stockage', width: 180, valueGetter: (params) => params.row.storageLocation.name },
      { field: 'notes', headerName: 'Notes', width: 300 },
      { field: 'createdAt', headerName: 'Enregistré le', width: 145, valueGetter: (params) => moment(params.row.createdAt).format('DD/MM/YYYY HH:mm'), },
      { field: 'createdBy', headerName: 'Par', width: 140, valueGetter: (params) => `${params.row.createdBy?.firstName || ''} ${params.row.createdBy?.lastName || ''}` },
    ],
    [],
  )

  return (
    <BaseConfigTable<StockTransactionDto>
      columns={columns}
      selectRows={(state) => state.stockTransaction.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setStockTransactionFilters({}))
        return dispatch(getStockTransactions())
      }}
      withActions={false}
      toolbarExtras={<StocksTableTabs />}
      toolbarExtrasPosition="left"
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setStockTransactionFilters({ page }))
        dispatch(getStockTransactions())
      }}
      FormComponent={({ onClose }) => (
        <StockTransactionForm onClose={onClose} />
      )}
      resourceLabel="transaction de stock"
      resourcePrefix="la "
    />
  )
}
